const smsMessageTemplateOnly = ["messageTemplate", "lineMessageTemplateNotAllowed", "pushMessageTemplateNotAllowed"];

export const shownFieldListForIPSATrigger = (triggerType, form) => {
  if (triggerType === "IPSA_BIRTHDAY") {
    form.frequency = "monthly";
    return ["messageTemplate"];
  } else if (
    triggerType === "IPSA_SKIN_CHECKUP" ||
    triggerType === "IPSA_PROSPECT"
  ) {
    form.frequency = "monthly";
    return ["messageTemplate", "skinCheckupProduct"];
  } else if (
    triggerType === "IPSA_WELCOME_2" ||
    triggerType === "IPSA_WELCOME_3" ||
    triggerType === "IPSA_THANK_YOU_(EXISTING)_WITH_PURCHASE"
  ) {
    form.frequency = "daily";
    return ["messageTemplate"];
  } else if (triggerType === "IPSA_WELCOME_1") {
    form.frequency = "daily";
    return ["messageTemplate", "billType"];
  } else if (triggerType === "IPSA_PRE_LAPSED") {
    form.frequency = "monthly";
    return ["messageTemplate", "prelapsedPeriod"];
  } else if (triggerType === "IPSA_LEAD_CUSTOMERS") {
    form.frequency = "daily";
    return smsMessageTemplateOnly;
  }
};

export const shownFieldListForNARSTrigger = (triggerType, form) => {
  if (triggerType === "NARS_BIRTHDAY") {
    form.frequency = "monthly";
    return ["messageTemplate"];
  } else if (
    triggerType === "NARS_WELCOME_WITHOUT_PURCHASE" ||
    triggerType === "NARS_THANK_YOU_(EXISTING)_WITH_PURCHASE"
  ) {
    form.frequency = "daily";
    return ["messageTemplate"];
  } else if (triggerType === "NARS_PRE_LAPSED") {
    form.frequency = "monthly";
    return ["messageTemplate", "prelapsedPeriod"];
  } else if (triggerType === "NARS_TOUCH_3_AND_4") {
    form.frequency = "daily";
    return [
      "messageTemplate",
      "afterFirstBillDayPeriod",
      "withOrWithoutPurchase",
    ];
  } else if (triggerType === "NARS_TOUCH_2") {
    form.frequency = "daily";
    return ["messageTemplateByCategories"];
  } else if (triggerType === "NARS_TOUCH_1") {
    form.frequency = "daily";
    return ["messageTemplate", "top40"];
  } else if (triggerType === "NARS_LEAD_CUSTOMERS") {
    form.frequency = "daily";
    return smsMessageTemplateOnly;
  }
};

export const shownFieldListForShiseidoTrigger = (triggerType, form) => {
  if (triggerType === "Shiseido FIRST WELCOME") {
    form.frequency = "daily";
    return ["messageTemplate", "billType"];
  } else if (triggerType === "Shiseido TOUCH 1 AND 2") {
    form.frequency = "daily";
    return ["messageTemplate", "afterFirstBillDayPeriod"];
  } else if (triggerType === "Shiseido PRE LAPSED AND LAPSED") {
    form.frequency = "monthly";
    return [
      "monthNotPurchasePeriod",
      "minTotalPurchase",
      "messageTemplatesForHvAndLv",
    ];
  } else if (triggerType === "Shiseido REPLENISHMENT") {
    form.frequency = "daily";
    return ["messageTemplate", "daysAfterLastPurchase"];
  } else if (triggerType === "Shiseido PROMISE YOU") {
    form.frequency = "daily";
    return [
      "messageTemplate",
      "afterFirstBillDayPeriod",
      "PurchaseSfsLxOption",
    ];
  } else if (triggerType === "Shiseido BIRTHDAY") {
    form.frequency = "monthly";
    return ["minSpendAndMessageTemplateGroup"];
  } else if (triggerType === "Shiseido THANK YOU (EXISTING) WITH PURCHASE") {
    form.frequency = "daily";
    return ["messageTemplate"];
  } else if (triggerType === "Shiseido LEAD CUSTOMERS") {
    form.frequency = "daily";
    return smsMessageTemplateOnly;
  }
};

export const shownFieldListForCPBTrigger = (triggerType, form) => {
  if (
    triggerType === "CPB WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE"
  ) {
    form.frequency = "daily";
    return ["messageTemplate", "billType"];
  } else if (triggerType === "CPB REPLENISHMENT & TOUCH I & TOUCH II") {
    form.frequency = "daily";
    return ["messageTemplate", "daysAfterLastPurchase"];
  } else if (
    triggerType === "CPB PROSPECT CONVERSION & NEW MEMBER CULTIVATION"
  ) {
    form.frequency = "daily";
    return ["messageTemplate", "billType", "daysAfterFirstBill"];
  } else if (triggerType === "CPB BIRTHDAY") {
    form.frequency = "monthly";
    return ["messageTemplateByMembership"];
  } else if (triggerType === "CPB THANK YOU (EXISTING) WITH PURCHASE") {
    form.frequency = "daily";
    return ["messageTemplate"];
  } else if (triggerType === "CPB PRE LAPSED AND LAPSED") {
    form.frequency = "monthly";
    return [
      "monthNotPurchasePeriod",
      "minTotalPurchase",
      "messageTemplatesForHvAndLv",
    ];
  } else if (triggerType === "CPB LEAD CUSTOMERS") {
    form.frequency = "daily";
    return smsMessageTemplateOnly;
  }
};

export const shownFieldListForDETrigger = (triggerType, form) => {
  if (triggerType === "DE THANK YOU (EXISTING) WITH PURCHASE") {
    form.frequency = "daily";
    return ["messageTemplate"];
  } else if (triggerType === "DE PRE LAPSED AND LAPSED") {
    form.frequency = "monthly";
    return ["messageTemplate", "prelapsedPeriod"];
  } else if (triggerType === "DE REPLENISHMENT") {
    form.frequency = "daily";
    return ["messageTemplate", "daysAfterLastPurchase"];
  } else if (triggerType === "DE BIRTHDAY") {
    form.frequency = "monthly";
    return ["messageTemplate"];
  } else if (
    triggerType === "DE PROSPECT CONVERSION & NEW MEMBER CULTIVATION"
  ) {
    form.frequency = "daily";
    return ["messageTemplate", "billType", "daysAfterFirstBill"];
  } else if (
    triggerType === "DE WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE"
  ) {
    form.frequency = "daily";
    return ["messageTemplate", "billType"];
  } else if (triggerType === "DE LEAD CUSTOMERS") {
    form.frequency = "daily";
    return smsMessageTemplateOnly;
  }
};

const sharedTriggerConfigForSFAndEI = {
  "WELCOME (NO PURCHASE) & THANK YOU (NEW) WITH PURCHASE": {
    frequency: "daily",
    fieldList: ["messageTemplate", "billType"],
  },
  "PROSPECT CONVERSION & NEW MEMBER CULTIVATION": {
    frequency: "daily",
    fieldList: ["messageTemplate", "billType", "daysAfterFirstBill"],
  },
  BIRTHDAY: {
    frequency: "monthly",
    fieldList: ["messageTemplate"],
  },
  REPLENISHMENT: {
    frequency: "daily",
    fieldList: ["messageTemplate", "daysAfterLastPurchase"],
  },
  "PRE LAPSED AND LAPSED": {
    frequency: "monthly",
    fieldList: ["messageTemplate", "prelapsedPeriod"],
  },
  "THANK YOU (EXISTING) WITH PURCHASE": {
    frequency: "daily",
    fieldList: ["messageTemplate"],
  },
  "LEAD CUSTOMERS": {
    frequency: "daily",
    fieldList: smsMessageTemplateOnly,
  },
};

export const shownFieldListForSFOrEITrigger = (triggerType, form) => {
  const [prefix, ...rest] = triggerType.split(" ");
  const key = rest.join(" ");

  if (prefix === "SF" || prefix === "EI") {
    const config = sharedTriggerConfigForSFAndEI[key];

    if (config) {
      form.frequency = config.frequency;
      return config.fieldList;
    }
  }
};
